import PropTypes from 'prop-types'
import { Component } from 'react'

import cn from '@/utilities/cn'

import './index.scss'

export default class Result extends Component<any, any> {
  static displayName = 'Result'

  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    data: PropTypes.shape({ id: PropTypes.string }),
    onChange: PropTypes.func
  }

  static defaultProps = {
    className: null,
    data: null,
    onChange: null
  }

  onChange = () => {
    if (this.props.onChange) {
      this.props.onChange(this.props.data)
    }
  }

  render() {
    // MUST use `onMouseDown` as it precedes `onBlur` from `Input` whereas `onClick` events do not
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div className={cn('autocomplete__result', this.props.className)} onMouseDown={this.onChange}>
        {this.props.children}
      </div>
    )
  }
}
